module.exports = __webpack_public_path__ + "img/home_pc_yousee.37bbf914.jpg";